import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import styles from './DiscountNavigation.module.scss';

export default function DiscountNavigation({ navigationGroups = [] }) {
  const numberOfNavigationGroups = navigationGroups?.length ?? 0;

  const navGroupLayoutCss =
    numberOfNavigationGroups === 5
      ? styles.nav_items_container_five_items
      : numberOfNavigationGroups % 3 === 0
      ? styles.nav_items_container_divisible_by_three
      : styles.nav_items_container;

  return (
    <section
      className={classNames('mx-auto my-10 w-100 px-8', styles.nav_section)}
    >
      <ul className={classNames('list-unstyled', navGroupLayoutCss)}>
        {navigationGroups.map((group) => {
          const { header, image, subheader, url } = group;
          return (
            <li key={image?.alt ?? header} className="p-0">
              <Link href={url}>
                <div className="d-flex flex-column h-100">
                  <div
                    className={classNames(
                      'mx-auto position-relative',
                      styles.image_container
                    )}
                  >
                    <div
                      className={classNames(
                        'h-100 w-100 position-absolute',
                        styles.image_wrapper
                      )}
                    >
                      <Image
                        fill
                        legacy
                        className="mw-100"
                        objectFit="cover"
                        src={image?.url}
                        alt={image?.alt}
                        sizes="(max-width: 992px) 50vw, 25vw"
                      />
                    </div>
                  </div>
                  <div
                    className={classNames(
                      'd-flex flex-column w-100 my-5 font-roboto',
                      styles.nav_item_text
                    )}
                  >
                    <p className="font-roboto fw-600 my-0 fs-7 fs-md-9">
                      {header}
                    </p>
                    <p className="d-none d-md-block fs-7">{subheader}</p>
                  </div>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
